import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  CollectionReference,
  DocumentChangeAction,
  DocumentReference,
} from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';
import { Live } from '../models/live.model';
import { DateService } from './date.service';

@Injectable({
  providedIn: 'root',
})
export class LiveService {
  private collection: CollectionReference<Live>;

  constructor(private firestore: AngularFirestore, private dateS: DateService) {
    this.collection = this.firestore.collection<Live>('lives').ref;
  }

  // Subscripbirse a todos los elementos
  subAll(): Observable<DocumentChangeAction<Live>[]> {
    return this.firestore.collection<Live>('lives', (ref) => ref.orderBy('name')).snapshotChanges();
  }

  // Obtener todos los elementos
  async getAll(): Promise<Live[]> {
    const snap = await this.collection.orderBy('name').get();
    const data = snap.docs.map((o) => {
      return { ...o.data(), uid: o.id };
    });
    return data;
  }

  // Obtener los datos de una fecha antes de que terminen
  async getValidLives(): Promise<Live[]> {
    const date = await this.dateS.dateNow();
    const snap = await this.collection.orderBy('name').where('endAt', '>=', date).get();
    const data = snap.docs.map((o) => {
      return { ...o.data(), uid: o.id };
    });
    return data.sort((a, b) => {
      const aStartAt = a.startAt.toDate().getTime();
      const bStartAt = b.startAt.toDate().getTime();
      return aStartAt - bStartAt; // Esto ordena en orden ascendente por startAt
    });
  }

  // Obtener un elemento por ID
  async getById(uid: string): Promise<Live | null> {
    const snap = await this.collection.doc(uid).get();
    if (snap.exists) {
      const data = { uid: snap.id, ...snap.data() } as Live;
      return data;
    } else {
      return null;
    }
  }

  getRef(uid: string): DocumentReference<Live> {
    return this.firestore.doc<Live>(`lives/${uid}`).ref;
  }

  // Crear un nuevo elemento
  async create(item: Live): Promise<string> {
    const result = await this.collection.add(item);
    return result.id;
  }

  // Actualizar un elemento
  async update(uid: string, item: Live): Promise<void> {
    await this.collection.doc(uid).update(item);
  }

  // Eliminar un elemento
  async delete(uid: string): Promise<void> {
    await this.collection.doc(uid).delete();
  }
}
